import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

// �??�??�?? Tipler �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

interface Odeme {
    odemeID: number;
    cariID: number;
    islemTarihi: string;
    vadeTarihi?: string | null;
    tahsilatTarihi?: string | null;
    miktar: number;
    odemeYonu: string;
    odemeDurumu: string;
    sozlesmeOdemesi: boolean;
    aktifMi: boolean;
    aciklama?: string | null;
    islemTakipNo: string;
    projeID?: number | null;
    cari: {
        cariID: number;
        adiSoyadi: string;
        firmaAdi?: string | null;
    };
    sozlesme?: {
        sozlesmeID: number;
        sozlesmeTakipNo: string;
        projeID?: number | null;
        projeAdi?: string | null;
        daireNo?: string | null;
    } | null;
    ilgiliProje?: {
        projeID: number;
        projeAdi: string;
    } | null;
}

interface SozlesmeKayit {
    sozlesmeID: number;
    sozlesmeFiyati: number;
    sozlesmeDurumu: string;
    aktifMi: boolean;
    cari: { cariID: number; adiSoyadi: string; firmaAdi?: string | null; telefon?: string | null; email?: string | null };
    daire: {
        daireID: number;
        daireNo: string;
        blok?: {
            blokAdi: string;
            proje?: { projeID: number; projeAdi: string } | null;
        } | null;
    };
}

interface MusteriSatir {
    cariID: number;
    musteriAdi: string;
    firmaAdi?: string | null;
    telefon?: string | null;
    email?: string | null;
    projeDaire: string;
    sozlesmeTutar: number;
    tahsilEdilen: number;
    fark: number;
    gecikmis: number;
    gecikmisAlacak: number;
    gecikmisOdenmemis: number;
    satirlar: Odeme[];
}

// �??�??�?? Dönem Tipleri �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

type Donem = 'bu-ay' | 'gecen-ay' | 'bu-yil' | 'son-3-ay' | 'tum' | 'ozel';

const DONEM_ETIKETLER: Record<Donem, string> = {
    'bu-ay': 'Bu Ay',
    'gecen-ay': 'Geçen Ay',
    'bu-yil': 'Bu Yıl',
    'son-3-ay': 'Son 3 Ay',
    'tum': 'Tüm Zamanlar',
    'ozel': 'Özel',
};

function getDonemRange(donem: Donem): { baslangic: Date; bitis: Date } {
    const now = new Date();
    const bugun = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    switch (donem) {
        case 'bu-ay':
            return { baslangic: new Date(now.getFullYear(), now.getMonth(), 1), bitis: bugun };
        case 'gecen-ay': {
            const gm = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const gmSon = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
            return { baslangic: gm, bitis: gmSon };
        }
        case 'bu-yil':
            return { baslangic: new Date(now.getFullYear(), 0, 1), bitis: bugun };
        case 'son-3-ay':
            return { baslangic: new Date(now.getFullYear(), now.getMonth() - 3, 1), bitis: bugun };
        case 'tum':
            return { baslangic: new Date(2000, 0, 1), bitis: bugun };
        default:
            return { baslangic: new Date(now.getFullYear(), 0, 1), bitis: bugun };
    }
}

// �??�??�?? Formatlar �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

const fmtTL = (n: number) =>
    '₺' + n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtOran = (n: number) => '%' + n.toFixed(1);

const fmtDate = (s?: string | null) =>
    s ? new Date(s).toLocaleDateString('tr-TR') : '—';

// �??�??�?? Tablo Stil Sabitleri �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

const TH: React.CSSProperties = {
    padding: '7px 10px',
    border: '1px solid #555',
    background: '#e0e0e0',
    fontWeight: 700,
    fontSize: 11,
    color: '#111',
    textAlign: 'left',
    whiteSpace: 'nowrap',
};

const TH_R: React.CSSProperties = { ...TH, textAlign: 'right' };

const TD: React.CSSProperties = {
    padding: '7px 10px',
    border: '1px solid #ccc',
    fontSize: 11,
    color: '#111',
    verticalAlign: 'middle',
};

const TD_R: React.CSSProperties = { ...TD, textAlign: 'right' };

// �??�??�?? Ana Bile�?en �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

export default function TahsilatPerformans() {
    const navigate = useNavigate();

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [odemeler, setOdemeler] = useState<Odeme[]>([]);
    const [sadeceBorclu, setSadeceBorclu] = useState(false);
    const [aramaMetni, setAramaMetni] = useState('');
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());
    const [tahsilEdilmesiGerekenAPI, setTahsilEdilmesiGerekenAPI] = useState<{ toplam: number; taksitliAlacak: number; taksitsizAlacak: number } | null>(null);
    const [sozlesmeler, setSozlesmeler] = useState<SozlesmeKayit[]>([]);
    const [musteriGecikmisMap, setMusteriGecikmisMap] = useState<Map<number, number>>(new Map());
    const [musteriGecikmisOdenmemisMap, setMusteriGecikmisOdenmemisMap] = useState<Map<number, number>>(new Map());
    const [sadecGecikmisAlacak, setSadecGecikmisAlacak] = useState(false);

    // �??�?? Veri Yükleme �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

    const fetchOdemeler = useCallback(async () => {
        setLoading(true);
        try {
            const [odRes, tahRes, sozRes, gRes] = await Promise.all([
                axiosInstance.get('/api/Odemeler', { params: { aktifMi: true } }),
                axiosInstance.get('/api/Odemeler/tahsil-edilmesi-gereken'),
                axiosInstance.get('/api/Sozlesmeler', { params: { aktifMi: true } }),
                axiosInstance.get('/api/Odemeler/tahsil-edilmesi-gereken-musteri'),
            ]);
            setOdemeler(odRes.data);
            setTahsilEdilmesiGerekenAPI(tahRes.data);
            setSozlesmeler(sozRes.data);
            const map = new Map<number, number>();
            const map2 = new Map<number, number>();
            (gRes.data as { cariID: number; gecikmisAlacak: number; gecikmisOdenmemis: number }[]).forEach(x => {
                map.set(x.cariID, x.gecikmisAlacak);
                map2.set(x.cariID, x.gecikmisOdenmemis);
            });
            setMusteriGecikmisMap(map);
            setMusteriGecikmisOdenmemisMap(map2);
        } catch {
            toast.error(t('msg.islemHatasi'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchOdemeler(); }, [fetchOdemeler]);

    // �??�?? Yardımcı Fonksiyonlar �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??
    // Sistemde odemeYonu sadece 'Tahsilat' veya 'Odeme' olabilir.
    // islemTakipNo prefix'i tür belirler: GEL-* = Gelir, GID-* = Gider, TAH-* = Tahsilat (kasa giri�?i)

    const isTaksitOdeme = (o: Odeme) => /^\d+\.\s*taksit/i.test(o.aciklama || '');
    const isBarterGelir = (o: Odeme) =>
        o.islemTakipNo.startsWith('GEL-') &&
        (o.aciklama?.toLowerCase().includes('barter') || o.aciklama?.toLowerCase().includes('mahsup'));

    // �??�?? Tüm Kayıtlar (dönem filtresi yok �?? anlık rapor) �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

    // Gelir kayıtları: islemTakipNo GEL- ile ba�?layanlar
    const gelirler = useMemo(() =>
        odemeler.filter(o => o.islemTakipNo.startsWith('GEL-')),
        [odemeler]
    );

    // Gerçek nakit tahsilat: GEL- olmayan Tahsilat kayıtları (taksit hariç)
    const tahsilatKalemler = useMemo(() =>
        odemeler.filter(o =>
            o.odemeYonu === 'Tahsilat' &&
            !o.islemTakipNo.startsWith('GEL-') &&
            !isTaksitOdeme(o)
        ),
        [odemeler]
    );

    // Barter/Mahsup açıklamalı gelirler (GEL-* içinden)
    const barterGelirler = useMemo(() => gelirler.filter(isBarterGelir), [gelirler]);

    // Taksit kayıtları (vadeli ödeme planı)
    const tumTaksitler = useMemo(() => odemeler.filter(isTaksitOdeme), [odemeler]);

    // �??�?? �?zet Metrikler �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

    const toplamGelir = useMemo(() => gelirler.reduce((s, o) => s + o.miktar, 0), [gelirler]);
    const toplamBarterGelir = useMemo(() => barterGelirler.reduce((s, o) => s + o.miktar, 0), [barterGelirler]);
    // Tahsil edilmesi gereken = vadesi gelmiş taksitler + taksitsiz sözleşme bakiyeleri (backend'den)
    const tahsilEdilmesiGereken = tahsilEdilmesiGerekenAPI?.toplam ?? 0;
    // Kasaya giren tahsilat = sadece Tahsilat türü kayıtlar
    const toplamTahsilEdilen = useMemo(() => tahsilatKalemler.reduce((s, o) => s + o.miktar, 0), [tahsilatKalemler]);
    const toplamFark = tahsilEdilmesiGereken - toplamTahsilEdilen;
    const basariOrani = tahsilEdilmesiGereken > 0 ? (toplamTahsilEdilen / tahsilEdilmesiGereken) * 100 : 0;

    const tehlikeDurumu = toplamFark > 0 && basariOrani < 60;
    const dikkatDurumu = toplamFark > 0 && basariOrani >= 60 && basariOrani < 85;
    const uyariRengi = tehlikeDurumu ? '#b91c1c' : dikkatDurumu ? '#b45309' : '#15803d';
    const uyariBG = tehlikeDurumu ? '#fef2f2' : dikkatDurumu ? '#fffbeb' : '#f0fdf4';
    const solCizgiRengi = tehlikeDurumu ? '#dc2626' : dikkatDurumu ? '#d97706' : '#16a34a';

    // �??�?? Müşteri Gruplama �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

    const musteriGruplari = useMemo(() => {
        const bugun = new Date(); bugun.setHours(23, 59, 59, 999);

        // Sözle�?meleri cariID'ye göre grupla (Ta�?eron hariç)
        const cariMap = new Map<number, { musteriAdi: string; firmaAdi?: string | null; telefon?: string | null; email?: string | null; sozlesmeTutar: number; projeler: Set<string> }>();
        sozlesmeler.filter(s => s.sozlesmeDurumu !== 'Taşeron').forEach(s => {
            const cid = s.cari.cariID;
            const projeAdi = s.daire?.blok?.proje?.projeAdi || '—';
            if (!cariMap.has(cid)) {
                cariMap.set(cid, { musteriAdi: s.cari.adiSoyadi, firmaAdi: null, telefon: s.cari.telefon, email: s.cari.email, sozlesmeTutar: 0, projeler: new Set() });
            }
            const entry = cariMap.get(cid)!;
            entry.sozlesmeTutar += s.sozlesmeFiyati;
            entry.projeler.add(projeAdi);
        });

        const arr: MusteriSatir[] = [];

        cariMap.forEach((entry, cariID) => {
            // Tahsil edilen = sadece Tahsilat türü kayıtlar
            const customerTahsilat = tahsilatKalemler.filter(o => o.cariID === cariID);
            const tahsilEdilenTutar = customerTahsilat.reduce((s, o) => s + o.miktar, 0);

            // Gecikmi�? taksitler = vadesi geçmi�? ödenmemi�?
            const gecikmisTaksitler = tumTaksitler.filter(o =>
                o.cariID === cariID &&
                o.vadeTarihi &&
                new Date(o.vadeTarihi) <= bugun &&
                o.odemeDurumu !== 'Odendi'
            );
            const gecikmis = gecikmisTaksitler.reduce((s, o) => s + o.miktar, 0);

            const projeDaire = Array.from(entry.projeler).join(', ');

            arr.push({
                cariID,
                musteriAdi: entry.musteriAdi,
                firmaAdi: entry.firmaAdi,
                telefon: entry.telefon,
                email: entry.email,
                projeDaire,
                sozlesmeTutar: entry.sozlesmeTutar,
                tahsilEdilen: tahsilEdilenTutar,
                fark: entry.sozlesmeTutar - tahsilEdilenTutar,
                gecikmis,
                gecikmisAlacak: musteriGecikmisMap.get(cariID) ?? 0,
                gecikmisOdenmemis: musteriGecikmisOdenmemisMap.get(cariID) ?? 0,
                satirlar: customerTahsilat,
            });
        });

        let result = arr;
        if (sadeceBorclu) result = result.filter(g => g.fark > 0);
        if (sadecGecikmisAlacak) result = result.filter(g => g.gecikmisOdenmemis > 0);
        if (aramaMetni) {
            const q = aramaMetni.toLowerCase();
            result = result.filter(g =>
                g.musteriAdi.toLowerCase().includes(q) ||
                (g.firmaAdi && g.firmaAdi.toLowerCase().includes(q)) ||
                g.projeDaire.toLowerCase().includes(q)
            );
        }
        result.sort((a, b) => b.fark - a.fark);
        return result;
    }, [sozlesmeler, tahsilatKalemler, tumTaksitler, sadeceBorclu, sadecGecikmisAlacak, aramaMetni, musteriGecikmisMap, musteriGecikmisOdenmemisMap]);

    const toggleRow = (id: number) => {
        setExpandedRows(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    // �??�?? Yardımcılar �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??

    const raporTarihi = new Date().toLocaleDateString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
    });

    const raporDonemAdi = new Date().toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });

    const durmAciklama = tehlikeDurumu
        ? t('tahsilat.kritik')
        : dikkatDurumu
            ? t('tahsilat.dikkat')
            : '✓ Hedef dahilinde';

    // �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??
    return (
        <div style={{ minHeight: '100vh', background: '#f1f5f9', fontFamily: 'Arial, Helvetica, sans-serif' }}>

            {/* �??�?? Action Bar �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
            <div className="tp-no-print" style={{
                background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '10px 24px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'sticky', top: 0, zIndex: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <button
                        onClick={() => navigate(-1)}
                        style={{ background: 'none', border: '1px solid #d1d5db', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13, color: '#374151' }}
                    >
                        ← Geri
                    </button>
                    <div>
                        <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>Tahsilat Performansı ve Gerçekleşme Raporu</span>
                        {loading && <span style={{ marginLeft: 10, fontSize: 11, color: '#94a3b8' }}>{t('msg.yukleniyor')}</span>}
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                    <button
                        onClick={fetchOdemeler}
                        disabled={loading}
                        style={{ background: '#f8fafc', border: '1px solid #d1d5db', padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, color: '#374151' }}
                    >
                        ↻ Yenile
                    </button>
                    <button
                        onClick={() => setSadecGecikmisAlacak(v => !v)}
                        style={{
                            background: sadecGecikmisAlacak ? '#b45309' : '#fef9c3',
                            color: sadecGecikmisAlacak ? '#fff' : '#92400e',
                            border: '1px solid #d97706',
                            padding: '5px 14px',
                            borderRadius: 6,
                            cursor: 'pointer',
                            fontSize: 13,
                            fontWeight: 600,
                        }}
                    >
                        ⚠ {sadecGecikmisAlacak ? t('label.tumu') : t('tahsilat.sadeceGecikmis')}
                    </button>
                    <button
                        onClick={() => window.print()}
                        style={{ background: '#1a2440', color: '#fff', border: 'none', padding: '5px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}
                    >
                        🖨 Yazdır / PDF
                    </button>
                </div>
            </div>

            {/* �??�?? Filtre �?ubu�?u �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
            <div className="tp-no-print" style={{
                maxWidth: 960, margin: '14px auto 0', padding: '12px 20px',
                background: '#fff', borderRadius: 10, border: '1px solid #e5e7eb',
                display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center',
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            }}>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#374151', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        <input type="checkbox" checked={sadeceBorclu} onChange={e => setSadeceBorclu(e.target.checked)} />
                        Sadece Borçluları Göster
                    </label>
                    <input
                        value={aramaMetni}
                        onChange={e => setAramaMetni(e.target.value)}
                        placeholder={t('label.ara')}
                        style={{ border: '1px solid #d1d5db', borderRadius: 6, padding: '5px 10px', fontSize: 12, minWidth: 170 }}
                    />
                </div>
            </div>

            {/* �??�?? Ekran KPI Şeridi �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
            <div className="tp-no-print" style={{
                maxWidth: 960, margin: '14px auto 0', padding: '0 20px',
                display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12,
            }}>
                {[
                    { label: 'Tahsil Edilmesi Gereken', value: fmtTL(tahsilEdilmesiGereken), sub: `${fmtTL(tahsilEdilmesiGerekenAPI?.taksitliAlacak ?? 0)} taksitli + ${fmtTL(tahsilEdilmesiGerekenAPI?.taksitsizAlacak ?? 0)} taksitsiz`, color: '#1a2440' },
                    { label: t('tahsilat.kasayaGiren'), value: fmtTL(toplamTahsilEdilen), sub: `${tahsilatKalemler.length} tahsilat kaydı`, color: '#15803d' },
                    { label: t('tahsilat.tahsilEdilmemis'), value: toplamFark > 0 ? fmtTL(toplamFark) : '—', sub: toplamFark > 0 ? 'Nakit tahsilat bekleniyor' : 'Hedefte', color: toplamFark > 0 ? uyariRengi : '#6b7280' },
                    { label: t('tahsilat.basariOrani'), value: fmtOran(basariOrani), sub: durmAciklama, color: uyariRengi },
                ].map(card => (
                    <div key={card.label} style={{
                        background: '#fff', borderRadius: 10, padding: '14px 16px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                        borderTop: `3px solid ${card.color}`,
                    }}>
                        <div style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>{card.label}</div>
                        <div style={{ fontSize: 17, fontWeight: 800, color: card.color, lineHeight: 1.2 }}>{card.value}</div>
                        <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 3 }}>{card.sub}</div>
                    </div>
                ))}
            </div>

            {/* ============================================================
                YAZDIRILABILIR A4 ALAN
            ============================================================ */}
            <div id="tp-print-area" style={{
                maxWidth: 960, margin: '18px auto 48px', background: '#fff',
                padding: '32px 40px', boxShadow: '0 1px 6px rgba(0,0,0,0.09)',
                fontFamily: 'Arial, Helvetica, sans-serif',
            }}>

                {/* �??�?? Ba�?lık �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
                <div style={{ borderBottom: '3px solid #000', paddingBottom: 14, marginBottom: 24 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                            <div style={{ fontSize: 20, fontWeight: 900, color: '#000', textTransform: 'uppercase', letterSpacing: '-0.5px' }}>
                                Tahsilat Performansı ve Gerçekleşme Raporu
                            </div>
                            <div style={{ fontSize: 12, color: '#444', marginTop: 4 }}>
                                Tarih: <strong>{raporDonemAdi}</strong> itibarıyla
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', fontSize: 11, color: '#555', lineHeight: 1.9 }}>
                            <div>Rapor Tarihi: <strong>{raporTarihi}</strong></div>
                            <div style={{ fontSize: 10, color: '#999' }}>YapiCRM</div>
                        </div>
                    </div>
                </div>

                {/* �??�?? A. Dönem �?zet Tablosu �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
                <div style={{ marginBottom: 30 }}>
                    <div style={{ fontWeight: 800, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', borderLeft: '4px solid #000', paddingLeft: 8, marginBottom: 10 }}>
                        A. Dönem Tahsilat Özeti
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2.5px solid #000' }}>
                        <thead>
                            <tr style={{ background: '#1a2440' }}>
                                <th style={{ ...TH, color: '#fff', border: '1px solid #243259', background: '#1a2440', width: '38%' }}>Gösterge</th>
                                <th style={{ ...TH_R, color: '#fff', border: '1px solid #243259', background: '#1a2440', width: '22%' }}>{t('label.tutar')}</th>
                                <th style={{ ...TH, color: '#fff', border: '1px solid #243259', background: '#1a2440' }}>Yorum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Satır 1: Vadesi gelen */}
                            <tr>
                                <td style={{ ...TD, fontWeight: 700, fontSize: 12, paddingTop: 12, paddingBottom: 12 }}>
                                    Bugüne Kadar Tahsil Edilmesi Gereken Tutar
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 17 }}>
                                    {fmtTL(tahsilEdilmesiGereken)}
                                </td>
                                <td style={{ ...TD, fontSize: 11, color: '#555' }}>
                                    Vadesi gelmiş taksitler (<strong>{fmtTL(tahsilEdilmesiGerekenAPI?.taksitliAlacak ?? 0)}</strong>) + taksitsiz sözleşme bakiyeleri (<strong>{fmtTL(tahsilEdilmesiGerekenAPI?.taksitsizAlacak ?? 0)}</strong>)
                                </td>
                            </tr>

                            {/* Satır 2: Gerçekle�?en */}
                            <tr style={{ background: '#f0fdf4' }}>
                                <td style={{ ...TD, fontWeight: 700, fontSize: 12, borderLeft: '4px solid #16a34a', paddingTop: 12, paddingBottom: 12 }}>
                                    Kasaya Giren Net Tahsilat
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 17, color: '#15803d' }}>
                                    {fmtTL(toplamTahsilEdilen)}
                                </td>
                                <td style={{ ...TD, fontSize: 11, color: '#555' }}>
                                    Tüm tahsilat belgeli ödemeler — <strong>{tahsilatKalemler.length}</strong> kayıt
                                </td>
                            </tr>

                            {/* Satır 3: Fark */}
                            <tr style={{ background: uyariBG }}>
                                <td style={{ ...TD, fontWeight: 700, fontSize: 12, borderLeft: `4px solid ${solCizgiRengi}`, paddingTop: 12, paddingBottom: 12 }}>
                                    Aradaki Fark — Gecikmiş Alacak
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 20, color: uyariRengi }}>
                                    {toplamFark > 0 ? `( ${fmtTL(toplamFark)} )` : '—'}
                                </td>
                                <td style={{ ...TD, fontSize: 11 }}>
                                    {toplamFark <= 0
                                        ? <span style={{ color: '#15803d' }}>✓ Tüm vadeli tahsilat tamamlanmış</span>
                                        : <span style={{ color: uyariRengi }}>
                                            <strong>{fmtTL(toplamFark)}</strong> tutarında gecikmiş / tahsil edilmemiş alacak
                                        </span>
                                    }
                                </td>
                            </tr>

                            {/* Satır 4: Ba�?arı oranı */}
                            <tr style={{ borderTop: '2.5px solid #000' }}>
                                <td style={{ ...TD, fontWeight: 700, fontSize: 12, borderLeft: `4px solid ${solCizgiRengi}`, paddingTop: 12, paddingBottom: 12 }}>
                                    Tahsilat Başarı Oranı
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 24, color: uyariRengi, letterSpacing: '-0.5px' }}>
                                    {fmtOran(basariOrani)}
                                </td>
                                <td style={{ ...TD, fontSize: 11 }}>
                                    {/* Progress bar */}
                                    <div style={{ background: '#e5e7eb', borderRadius: 4, height: 12, overflow: 'hidden', marginBottom: 6 }}>
                                        <div style={{
                                            background: uyariRengi,
                                            height: '100%',
                                            width: `${Math.min(basariOrani, 100)}%`,
                                            borderRadius: 4,
                                            transition: 'width 0.4s ease',
                                        }} />
                                    </div>
                                    <span style={{ color: uyariRengi, fontWeight: 600 }}>{durmAciklama}</span>
                                    <span style={{ color: '#888', marginLeft: 8, fontSize: 10 }}>
                                        (Hedef: ↗%85)
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* De�?erlendirme Kutusu */}
                    <div style={{
                        border: `2px solid ${tehlikeDurumu ? '#dc2626' : '#000'}`,
                        padding: '10px 14px',
                        marginTop: 12,
                        background: tehlikeDurumu ? '#fef2f2' : dikkatDurumu ? '#fffbeb' : '#f9fafb',
                        fontSize: 12,
                        lineHeight: 1.8,
                    }}>
                        <strong>Değerlendirme:</strong>{' '}
                        <strong>{raporDonemAdi}</strong> tarihi itibarıyla{' '}
                        vadesi gelmiş taksit alacakları <strong>{fmtTL(tahsilEdilmesiGerekenAPI?.taksitliAlacak ?? 0)}</strong> +
                        taksitsiz sözleşme bakiyeleri <strong>{fmtTL(tahsilEdilmesiGerekenAPI?.taksitsizAlacak ?? 0)}</strong> olmak üzere{' '}
                        bugüne kadar tahsil edilmesi gereken toplam tutar <strong>{fmtTL(tahsilEdilmesiGereken)}</strong>;
                        gerçekleşen tahsilat{' '}
                        <strong style={{ color: '#15803d' }}>{fmtTL(toplamTahsilEdilen)}</strong> ({fmtOran(basariOrani)}) kasaya girmiştir.
                        {toplamFark > 0 ? (
                            <>
                                {' '}<strong style={{ color: uyariRengi }}>
                                    {fmtTL(toplamFark)} tutarında gecikmiş alacak bulunmaktadır.
                                </strong>
                                {tehlikeDurumu && ' ⚠ Acil takip gereklidir.'}
                            </>
                        ) : (
                            <> Tüm vadeli tahsilat başarıyla gerçekleştirilmiştir.</>
                        )}
                    </div>
                </div>

                {/* �??�?? B. Müşteri Bazlı Tablo �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
                <div style={{ fontWeight: 800, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', borderLeft: '4px solid #000', paddingLeft: 8, marginBottom: 10 }}>
                    B. Müşteri Bazlı Tahsilat Gerçekleşme Tablosu
                    <span style={{ fontSize: 10, fontWeight: 400, marginLeft: 8, color: '#666', textTransform: 'none' }}>
                        ({musteriGruplari.length} müşteri — büyükten küçüğe borç sırası)
                    </span>
                </div>

                {musteriGruplari.length === 0 ? (
                    <div style={{ border: '1.5px solid #ccc', padding: '20px', textAlign: 'center', color: '#888', fontStyle: 'italic', fontSize: 12 }}>
                        {gelirler.length === 0 && tahsilatKalemler.length === 0
                            ? 'Seçilen dönemde gelir veya tahsilat kaydı bulunamadı.'
                            : 'Filtreye uyan müşteri bulunamadı.'}
                    </div>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000' }}>
                        <thead>
                            <tr style={{ background: '#e0e0e0' }}>
                                <th style={{ ...TH, width: 28, textAlign: 'center' }}>#</th>
                                <th style={TH}>Müşteri Adı</th>
                                <th style={TH}>Proje / Daire</th>
                                <th style={TH_R}>Sözleşme Tutarı</th>
                                <th style={TH_R}>Tahsil Edilen</th>
                                <th style={TH_R}>Kalan Borç</th>
                                <th style={{ ...TH_R, width: 60 }}>Oran</th>
                                <th style={{ ...TH_R, background: '#fef9c3', color: '#92400e', width: 130 }}>Gecikmiş Alacak</th>
                                <th className="tp-no-print" style={{ ...TH, width: 36, textAlign: 'center' }}>Det.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {musteriGruplari.map((g, idx) => {
                                const oran = g.sozlesmeTutar > 0 ? (g.tahsilEdilen / g.sozlesmeTutar) * 100 : 0;
                                const borclu = g.fark > 0;
                                const oranRenk = oran < 60 ? '#b91c1c' : oran < 85 ? '#b45309' : '#15803d';
                                const satirBG = borclu
                                    ? (oran < 60 ? '#fff8f8' : '#fffef5')
                                    : '#f9fdf9';
                                const expanded = expandedRows.has(g.cariID);

                                return (
                                    <React.Fragment key={g.cariID}>
                                        <tr style={{ background: satirBG, borderBottom: '1px solid #d4d4d4' }}>
                                            <td style={{ ...TD, textAlign: 'center', color: '#888', fontSize: 10 }}>{idx + 1}</td>
                                            <td style={{ ...TD, fontWeight: 600 }}>
                                                <div>{g.musteriAdi}</div>
                                                {g.firmaAdi && (
                                                    <div style={{ fontSize: 10, color: '#666', fontWeight: 400, marginTop: 1 }}>{g.firmaAdi}</div>
                                                )}
                                                {g.telefon && (
                                                    <div style={{ fontSize: 10, color: '#3b82f6', fontWeight: 400, marginTop: 1 }}>{g.telefon}</div>
                                                )}
                                                {g.email && (
                                                    <div style={{ fontSize: 10, color: '#6b7280', fontWeight: 400, marginTop: 1 }}>{g.email}</div>
                                                )}
                                            </td>
                                            <td style={{ ...TD, fontSize: 11, color: '#444' }}>{g.projeDaire}</td>
                                            <td style={{ ...TD_R, fontWeight: 700 }}>{fmtTL(g.sozlesmeTutar)}</td>
                                            <td style={{ ...TD_R, fontWeight: 700, color: '#15803d' }}>{fmtTL(g.tahsilEdilen)}</td>
                                            <td style={{
                                                ...TD_R,
                                                fontWeight: 800,
                                                color: borclu ? oranRenk : '#15803d',
                                                borderLeft: borclu ? `3px solid ${oranRenk}` : TD_R.border as string,
                                            }}>
                                                {borclu ? fmtTL(g.fark) : '—'}
                                            </td>
                                            <td style={{ ...TD_R, fontWeight: 700, color: oranRenk }}>
                                                {fmtOran(oran)}
                                            </td>
                                            <td style={{
                                                ...TD_R,
                                                fontSize: 11,
                                                fontWeight: 800,
                                                background: g.gecikmisOdenmemis > 0 ? '#fefce8' : undefined,
                                                color: g.gecikmisOdenmemis > 0 ? '#b45309' : '#94a3b8',
                                                borderLeft: g.gecikmisOdenmemis > 0 ? '3px solid #d97706' : undefined,
                                            }}>
                                                {g.gecikmisOdenmemis > 0 ? `( ${fmtTL(g.gecikmisOdenmemis)} )` : '—'}
                                            </td>
                                            <td className="tp-no-print" style={{ ...TD, textAlign: 'center' }}>
                                                <button
                                                    onClick={() => toggleRow(g.cariID)}
                                                    title={expanded ? 'Kapat' : 'Kalemleri Gör'}
                                                    style={{
                                                        background: expanded ? '#1a2440' : '#f1f5f9',
                                                        color: expanded ? '#fff' : '#374151',
                                                        border: '1px solid #cbd5e1',
                                                        borderRadius: 4,
                                                        width: 26,
                                                        height: 26,
                                                        cursor: 'pointer',
                                                        fontSize: 11,
                                                        lineHeight: 1,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {expanded ? '▲' : '▼'}
                                                </button>
                                            </td>
                                        </tr>

                                        {/* Alt Tablo (Kalem Detayı) */}
                                        {expanded && (
                                            <tr className="tp-no-print">
                                                <td colSpan={9} style={{
                                                    padding: '0 0 4px 40px',
                                                    background: '#f8f9fa',
                                                    borderBottom: '2px solid #999',
                                                }}>
                                                    <table style={{ width: '98%', borderCollapse: 'collapse', margin: '6px 0', fontSize: 11 }}>
                                                        <thead>
                                                            <tr style={{ background: '#e8e8e8' }}>
                                                                <th style={{ ...TH, fontSize: 10 }}>Vade Tarihi</th>
                                                                <th style={{ ...TH, fontSize: 10 }}>İşlem No</th>
                                                                <th style={{ ...TH, fontSize: 10 }}>{t('label.aciklama')}</th>
                                                                <th style={{ ...TH_R, fontSize: 10 }}>{t('label.tutar')}</th>
                                                                <th style={{ ...TH, fontSize: 10 }}>{t('label.durum')}</th>
                                                                <th style={{ ...TH, fontSize: 10 }}>Tahsilat Tarihi</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {g.satirlar
                                                                .slice()
                                                                .sort((a, b) =>
                                                                    new Date(a.vadeTarihi!).getTime() - new Date(b.vadeTarihi!).getTime()
                                                                )
                                                                .map(o => (
                                                                    <tr key={o.odemeID} style={{
                                                                        background: o.odemeDurumu === 'Odendi' ? '#f0fdf4' : '#fef2f2',
                                                                    }}>
                                                                        <td style={{ ...TD, fontSize: 10 }}>{fmtDate(o.vadeTarihi)}</td>
                                                                        <td style={{ ...TD, fontSize: 10, color: '#555' }}>{o.islemTakipNo}</td>
                                                                        <td style={{ ...TD, fontSize: 10, color: '#444' }}>{o.aciklama || '—'}</td>
                                                                        <td style={{ ...TD_R, fontSize: 10, fontWeight: 700 }}>{fmtTL(o.miktar)}</td>
                                                                        <td style={{ ...TD, fontSize: 10 }}>
                                                                            <span style={{
                                                                                padding: '2px 7px',
                                                                                borderRadius: 3,
                                                                                fontWeight: 600,
                                                                                fontSize: 10,
                                                                                background: o.odemeDurumu === 'Odendi' ? '#dcfce7' : '#fee2e2',
                                                                                color: o.odemeDurumu === 'Odendi' ? '#15803d' : '#b91c1c',
                                                                                border: `1px solid ${o.odemeDurumu === 'Odendi' ? '#bbf7d0' : '#fecaca'}`,
                                                                            }}>
                                                                                {o.odemeDurumu === 'Odendi' ? '✓ Ödendi' : '⏳ Bekliyor'}
                                                                            </span>
                                                                        </td>
                                                                        <td style={{ ...TD, fontSize: 10, color: '#666' }}>
                                                                            {fmtDate(o.tahsilatTarihi)}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr style={{ background: '#e0e0e0', borderTop: '2.5px solid #000' }}>
                                <td colSpan={3} style={{ ...TD, fontWeight: 800, fontSize: 12, borderColor: '#555' }}>
                                    GENEL TOPLAM — {musteriGruplari.length} Müşteri
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 12, borderColor: '#555' }}>
                                    {fmtTL(musteriGruplari.reduce((s, g) => s + g.sozlesmeTutar, 0))}
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 12, color: '#15803d', borderColor: '#555' }}>
                                    {fmtTL(musteriGruplari.reduce((s, g) => s + g.tahsilEdilen, 0))}
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 12, color: uyariRengi, borderColor: '#555' }}>
                                    {(() => { const t = musteriGruplari.reduce((s, g) => s + g.fark, 0); return t > 0 ? fmtTL(t) : '—'; })()}
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 12, color: uyariRengi, borderColor: '#555' }}>
                                    {fmtOran(basariOrani)}
                                </td>
                                <td style={{ ...TD_R, fontWeight: 900, fontSize: 12, background: '#fefce8', color: '#b45309', borderColor: '#555' }}>
                                    {fmtTL(musteriGruplari.reduce((s, g) => s + g.gecikmisOdenmemis, 0))}
                                </td>
                                <td className="tp-no-print" style={{ ...TD, borderColor: '#555' }}>&nbsp;</td>
                            </tr>
                        </tfoot>
                    </table>
                )}

                <div style={{ marginTop: 14, display: 'flex', justifyContent: 'space-between', fontSize: 9, color: '#999', borderTop: '1px solid #ccc', paddingTop: 6 }}>
                    <span>YapiCRM — Tahsilat Performansı ve Gerçekleşme Raporu &nbsp;|&nbsp; {raporDonemAdi}</span>
                    <span>Oluşturulma: {new Date().toLocaleString('tr-TR')}</span>
                </div>
            </div>

            {/* �??�?? Baskı Stilleri �??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�??�?? */}
            <style>{`
                @media print {
                    .tp-no-print { display: none !important; }
                    body { background: #fff !important; margin: 0 !important; }
                    #tp-print-area {
                        max-width: 100% !important;
                        margin: 0 !important;
                        padding: 10mm 12mm !important;
                        box-shadow: none !important;
                        font-size: 10px !important;
                    }
                    table { page-break-inside: auto; border-collapse: collapse !important; }
                    tr { page-break-inside: avoid; page-break-after: auto; }
                    thead { display: table-header-group; }
                    tfoot { display: table-footer-group; }
                    @page { size: A4 portrait; margin: 8mm; }
                }
            `}</style>
        </div>
    );
}
